var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _require = require("eth-lib/lib/hash"),
    keccak256 = _require.keccak256;

var _require2 = require('./bloom'),
    topicToBloom = _require2.topicToBloom;

var Envelope = function Envelope(message) {
  "use strict";

  _classCallCheck(this, Envelope);

  this.expiry = message[0];
  this.ttl = message[1];
  this.topic = message[2];
  this.data = message[3];
  this.nonce = message[4];
  this.message = message;
  this.id = keccak256(message.join(''));
  this.bloom = topicToBloom(this.topic);
};

module.exports = Envelope;